import gql from 'graphql-tag';

export const TeamListQuery = gql`
	query TeamListQuery(
		$first: Int,
		$cursor: String,
        $filter: SearchByNameInput
	) {
		entities: teams(first: $first, after: $cursor, filter: $filter) {
			edges {
				node {
					id
					localId
					name
				}
			}
			total
			pageInfo {
				hasNextPage
				hasPreviousPage
			}
		}

	}
`;


